/** Switching returns a token; a superseded review must never replace the live account with it. */
export async function ensureFeedbackAccount(
  accountId: string | undefined,
  target: string,
  isCurrent: () => boolean,
  switchAccount: (target: string) => Promise<{ token: string }>,
  commit: (token: string, target: string) => void,
): Promise<void> {
  if (!isCurrent() || target === accountId) return
  const { token } = await switchAccount(target)
  if (isCurrent()) commit(token, target)
}
